if(typeof __memcached === 'undefined') {var e = new Error("Cannot find module \"__memcached\""); e.code = 'MODULE_NOT_FOUND'; throw e;}
module.exports = __memcached;


/*****************
 ** WEBPACK FOOTER
 ** external "__memcached"
 ** module id = 554
 ** module chunks = 0
 **/